import axios from 'axios';
import { DUTY_API_URL } from '../../comm/config';
import { rewriteOBJ, rewriteNewOBJ } from '../commlogic';

const API_HOST = DUTY_API_URL;

const POST_LIST = {
  postCreateDaFootNote: '/create/footNote',
  postDeleteDaFootNote: '/delete/footNote',
  postUpdateDaFootNote: '/update/footNote',
  saveCheckInOut: '/save/checkInOut',
  clearCheckInOut: '/clear/checkInOut',
  postCteateTemporaryStaff: '/create/temporaryStaff',
  postDeleteTemporaryStaff: '/delete/temporaryStaff',
  postUpdateTemporaryStaff: '/update/temporaryStaff',
  postUpdateDaDuty: '/update/daDuty',
  postUpdateTemplateRoster: '/update/daDutyTemplateRoster',
  postCreateTemplateRoster: '/create/daDutyTemplateRoster',
  postDeleteTemplateRoster: '/daDutyTemplateRoster/del',
  postDeleteBatchTemplateRoster: '/daDutyTemplateRoster/deleteBatch',
  postCreateDaDutyTemplate: '/create/daDutyTemplate',
  postPushNotify: '/push/notifications',
  postPinFootNote: '/pin/footNote',
  postSaveAttendanceSetting: '/save/setting',
  postSaveRelievintSetting: '/save/relievingSetting',
  postUpdatePlannerOrder: '/updateRoster/order',
  postReOrderFootNote: '/order/footNote',
  saveDraft: '/daDuty/draft/save',
  overrideDraft: '/daDuty/draft/override',
  weekly: '/daDuty/weekly',
  updateRosterDispType: '/update/rosterDispType',
  saveDaDutyChatList: '/daDuty/chat/list',
  listDraftSummary: '/daDuty/draft/summary/list',
  publishDraftSummary: '/daDuty/draft/summary/publish',
  duplicateDraft: '/daDuty/draft/duplicate',
  // postTemplateStaff: '/import/temporaryStaff',
  saveDaDutyChatCategory: '/daDuty/chatCategory',
};

const DELETE_LIST = {
  deleteDaDutyChatCategoryList: '/daDuty/chatCategory',
};

const GET_LIST = {
  getDaDutyList: '/daDuty/draft/list',
  getDaStaffList: '/staff/list',
  getDaFootNote: '/footNote/list',
  getDaCheckList: '/checkInOut/list',
  getTemplateRoster: '/daDutyTemplateRoster/list',
  getTemplateWard: '/daDutyTemplateWard/list',
  getMyTemplate: '/myTemplate/list',
  getMyTemplateSmartCount: '/myTemplate/smartCount',
  getNotifications: '/notificationsStaff/list',
  getSrsStaffList: '/srsStaff/list',
  getRankList: '/srsRank/list',
  getShiftCode: '/srsShift/list',
  getUnitCode: '/srsUnit/list',
  getSettingDetail: '/setting/detail',
  getGroupList: '/srsGroup/list',
  getRelievintSetting: '/relievingSetting/detail',
  getResetDuty: '/reset/daDuty',
  getResetPrevDuty: '/resetPrev/daDuty',
  getVersion: '/daDuty/draft/version',
  getRosterDispType: '/rosterDispType/detail',
  getTemplateStaff: '/import/temporaryStaff',
  getDaDutyChatList: '/daDuty/chat/list',
  getDropDownLists: '/daDuty/chat/option',
  getIsRosterNameDetail: '/isRosterName/detail',
  getTemplateWardJTAOptions: '/daDutyTemplateWard/jta/option',
  getDaDutyChatCategoryList: '/daDuty/chatCategory',
};

const DUTYAPI = {
  POST: POST_LIST,
  GET: GET_LIST,
  DELETE: DELETE_LIST,
};

rewriteOBJ(DUTYAPI, API_HOST);

const NEWDUTYAPI = {
  POST: { postTemplateStaff: '/import/temporaryStaff' },
  GET: {},
};
rewriteNewOBJ(NEWDUTYAPI, API_HOST);

const getDaExportRequest = ({ wardId, templateRosterId }) => {
  return axios({
    method: 'get',
    url: `${API_HOST}/export/daDuty`,
    responseType: 'blob',
    params: { wardId, templateRosterId },
  });
};

const getDaExportAttendanceRequest = (payload) => {
  return axios({
    method: 'get',
    url: `${API_HOST}/export/attendance`,
    responseType: 'blob',
    params: payload,
  });
};

export default {
  ...DUTYAPI.GET,
  ...DUTYAPI.POST,
  ...DUTYAPI.DELETE,
  ...NEWDUTYAPI.POST,
  getDaExportRequest,
  getDaExportAttendanceRequest,
};
